/** Extracts a user-facing message from axios errors (including blob error bodies). */
export async function parseAxiosErrorMessage(error, fallback = 'Request failed.') {
  const data = error?.response?.data;
  if (data && typeof data === 'object' && !(data instanceof Blob) && data.message) {
    return data.message;
  }
  if (data instanceof Blob) {
    try {
      const text = await data.text();
      const parsed = JSON.parse(text);
      if (parsed?.message) return parsed.message;
      return text || fallback;
    } catch {
      return fallback;
    }
  }
  if (typeof data === 'string' && data) return data;
  return error?.message || fallback;
}
